import { render, staticRenderFns } from "./StockInformationPopover.vue?vue&type=template&id=1d3c7678&scoped=true"
import script from "./StockInformationPopover.vue?vue&type=script&lang=js"
export * from "./StockInformationPopover.vue?vue&type=script&lang=js"
import style0 from "./StockInformationPopover.scss?vue&type=style&index=0&id=1d3c7678&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3c7678",
  null
  
)

export default component.exports